import PropTypes from 'prop-types';
import React from 'react';
import BaseComponent from 'apps/new-web/views/component';
import Icon from 'apps/new-web/views/components/icon';
import { white } from 'apps/new-web/views/themes/colors';
import CHEVRON_DOWN_LINE from '@ifit/react-icons/dist/icons/CHEVRON_DOWN_LINE';
import I18n from 'apps/new-web/views/components/i18n';

export default class ArrowBounce extends BaseComponent {
  static get propTypes() {
    return {
      style: PropTypes.object,
      anchor: PropTypes.bool
    };
  }

  render() {
    return (
      <div
        className="arrow-bounce-component"
        aria-hidden="true"
        style={ this.props.style }
      >
        { this.props.anchor === false
          ? <Icon icon={ CHEVRON_DOWN_LINE } className="bouncy-arrow" color={ white } size={ 52 } />
          : <a href="#arrow-anchor" aria-label={ I18n.translate('Link to [ifit] [fusion] section.', { ifit: 'iFIT', fusion: 'Fusion' }, 'An anchor link directing a user to information on the iFIT Fusion app.' ) }>
            <Icon icon={ CHEVRON_DOWN_LINE } className="bouncy-arrow" color={ white } size={ 52 } />
          </a>
        }
      </div>
    );
  }
}
